export const CARET_HALF_WIDTH = 9;
export const CARET_HEIGHT = 10;
export const POPOVER_BORDER_RADIUS = 8;

export type CaretEdge = 'bottom' | 'left' | 'right' | 'top';

/** The edges the caret math reads, shared by DOMRect and virtual elements. */
export type MeasuredRect = Pick<DOMRect, 'height' | 'left' | 'top' | 'width'>;

export function isSameRect(a: MeasuredRect | null, b: MeasuredRect) {
  return (
    a !== null &&
    a.left === b.left &&
    a.top === b.top &&
    a.width === b.width &&
    a.height === b.height
  );
}

export function resolveCaretEdge(placement: string): CaretEdge {
  const side = placement.split('-')[0];
  if (side === 'top') return 'bottom';
  if (side === 'left') return 'right';
  if (side === 'right') return 'left';
  return 'top';
}

type ComputeCaretOffsetArgs = {
  axis: 'horizontal' | 'vertical';
  borderRadius: number;
  caretHalfWidth: number;
  popoverRect: MeasuredRect;
  triggerRect: MeasuredRect;
};

export function computeCaretOffset({
  axis,
  borderRadius,
  caretHalfWidth,
  popoverRect,
  triggerRect,
}: ComputeCaretOffsetArgs) {
  const raw =
    axis === 'horizontal'
      ? triggerRect.left + triggerRect.width / 2 - popoverRect.left
      : triggerRect.top + triggerRect.height / 2 - popoverRect.top;

  const popoverSize =
    axis === 'horizontal' ? popoverRect.width : popoverRect.height;
  const min = borderRadius + caretHalfWidth;
  const max = popoverSize - borderRadius - caretHalfWidth;

  return Math.min(Math.max(raw, min), max);
}
